import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_4 = {
  key: 1,
  class: "alert alert-warning py-2 small"
}
const _hoisted_5 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_text_area_ui = _resolveComponent("text-area-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: _ctx.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, { "is-show": _ctx.loader }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.subject)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Вы действительно хотите удалить ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.subject), 1),
                  _cache[3] || (_cache[3] = _createTextVNode("? "))
                ]))
              : _createCommentVNode("", true),
            (_ctx.warning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.warning), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": `Укажите причину удаления (от ${_ctx.minLength} до ${_ctx.maxLength} символов)`,
              label: "Причина удаления",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_area_ui, {
                  modelValue: _ctx.reason,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
                  "is-invalid": _ctx.visibleErrors && _ctx.isReasonError,
                  maxlength: _ctx.maxLength,
                  placeholder: _ctx.placeholder
                }, null, 8, ["modelValue", "is-invalid", "maxlength", "placeholder"])
              ]),
              _: 1
            }, 8, ["invalid-feedback"]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-text" }, " Запись не удаляется безвозвратно: её можно восстановить в разделе «Корзина». ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_button_ui, { "button-class": "btn-danger" }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Удалить ")
            ])),
            _: 1
          }),
          _createVNode(_component_button_ui, {
            "button-class": "btn-outline-secondary ms-3",
            type: "button",
            onClick: _ctx.cancel
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode(" Отмена ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}